import React from 'react';
import styles from './InfoCard.module.css';

const InfoCard = ({
    title,
    subtitle,
    icon,
    image,
    imagePosition = 'top',
    children,
    actions = [],
    variant = 'default',
    className = '',
    onClick,
    hoverable = false,
    selected = false,
    onSelect
}) => {
    const handleClick = () => {
        if (onClick) {
            onClick();
        } else if (onSelect) {
            onSelect(!selected);
        }
    };

    return (
        <article
            className={`${styles.card} ${styles[variant]} ${hoverable ? styles.hoverable : ''} ${selected ? styles.selected : ''} ${onClick || onSelect ? styles.clickable : ''} ${className}`}
            onClick={handleClick}
            role={onClick ? 'button' : undefined}
            tabIndex={onClick || onSelect ? 0 : undefined}
            onKeyDown={(e) => {
                if ((e.key === 'Enter' || e.key === ' ') && (onClick || onSelect)) {
                    e.preventDefault();
                    handleClick();
                }
            }}
            aria-pressed={selected}
        >
            {/* Изображение */}
            {image && imagePosition === 'top' && (
                <div className={styles.imageTop}>
                    <img src={image} alt="" className={styles.image} />
                </div>
            )}

            {/* Иконка */}
            {icon && (
                <div className={styles.icon}>
                    {icon}
                </div>
            )}

            {/* Контент */}
            <div className={styles.content}>
                {(title || subtitle) && (
                    <header className={styles.header}>
                        {title && <h3 className={styles.title}>{title}</h3>}
                        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
                    </header>
                )}

                {children && (
                    <div className={styles.body}>
                        {children}
                    </div>
                )}
            </div>

            {/* Действия */}
            {actions.length > 0 && (
                <footer className={styles.footer}>
                    {actions.map((action, index) => (
                        <button
                            key={index}
                            className={`${styles.actionButton} ${action.variant ? styles[action.variant] : ''}`}
                            onClick={(e) => {
                                e.stopPropagation();
                                if (action.onClick) {
                                    action.onClick();
                                }
                            }}
                            disabled={action.disabled}
                            title={action.title}
                        >
                            {action.icon && <span className={styles.actionIcon}>{action.icon}</span>}
                            {action.label && <span className={styles.actionLabel}>{action.label}</span>}
                        </button>
                    ))}
                </footer>
            )}

            {/* Изображение внизу */}
            {image && imagePosition === 'bottom' && (
                <div className={styles.imageBottom}>
                    <img src={image} alt="" className={styles.image} />
                </div>
            )}
        </article>
    );
};

export default InfoCard;
